const sidenav = {
	el: {
		win: $(window),
		html: $('html'),
		body: $('body'),
		header: $('.header'),
		hero: $('.shape-banner-bg'),
		sidenav: $('.sidenav'),
		sidenavItem: $('.sidenav__page-sub-item')
	},
	events() {
		// Check if the current page has the class below, if yes, the function works. Avoid js erros
		if (!this.el.sidenav.length) return

		const bannerHeight = this.el.hero.length ? this.el.hero.outerHeight() : 0;

		this.el.win.on('scroll', e => $(e.currentTarget).scrollTop() >= bannerHeight - this.el.header.outerHeight() ? this.el.sidenav.addClass('fixed').css('top', this.el.header.outerHeight()) : this.el.sidenav.removeClass('fixed').removeAttr('style'));

		this.el.sidenavItem.find('a').on('click', e => {
			const href = $(e.currentTarget).attr('href');
			setTimeout(() => {
				this.el.html.add(this.el.body).animate({
					scrollTop: $(href).offset().top - this.el.header.outerHeight()
				}, 500, () => {
					setTimeout(() => {
						history.pushState('', document.title, window.location.pathname + window.location.search)
					}, 1)
				})
			}, 1);

		});

		// Restore scroll history of browsers
		if ('scrollRestoration' in history) {
			history.scrollRestoration = 'manual'
		}

	},
	init() {
		this.events();
	}
}

sidenav.init();